// import Loader from 'common/components/Loader/Loader';
import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useOrganization from "common/hooks/useOrganization";
import useAuth from "common/hooks/useAuth";
import fetchJSON from "common/utils/fetchJSON";
import OrganizationForm from "./AccessRequestForm";

function AccessRequest() {
  const { t } = useTranslation();
  const router = useRouter();
  const { user: currentUser } = useAuth();
  const { organization: currentOrganization } = useOrganization();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const {
    item: accessRequest,
    error,
    isFetching,
  }: any = useItem("access-requests", id, {
    populate: ["user"],
  });

  const validateAccessRequest = useCallback(
    async (data: any) => {
      try {
        await fetchJSON({
          url: `access-requests/validate/${id}`,
          method: "POST",
          payload: data,
        });
      } catch (validateError) {
        console.error(
          "Erreur lors de la validation de la demande d'accès :",
          validateError
        );
      }
    },
    [id]
  );
  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate(
        currentUser?.isSuperadmin && !currentOrganization?.id
          ? "/access-requests"
          : "/"
      );
    }
  }, [setAlert, router, error, currentUser, currentOrganization, t]);

  const onSubmit = useCallback(
    async (data: any) => {
      const newData = { ...data };

      try {
        if (newData.id) {
          setAlert(t("common.error"), "error");
        } else {
          await validateAccessRequest(newData);
        }
      } catch (e: any) {
        setAlert(t("common.error"), "error");
        return e;
      }
      back();
      return true;
    },
    [back, validateAccessRequest, setAlert, t]
  );

  return isFetching || (id && !accessRequest) ? null : (
    <OrganizationForm onSubmit={onSubmit} item={accessRequest} />
  );
}

export default AccessRequest;
